import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M3 1H2v3h1v14h11v1h3v-3h-3v1H4V9h10v1h3V7h-3v1H4V4h1V1H3z" fill="#000" /></svg>;